module.exports = __webpack_public_path__ + "assets/contactform-bg.b8fa2ae1.svg";